module.exports = __webpack_public_path__ + "img/smgl@2x.c35c02f3.png";